import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";

import Api from "../../Api/Api";
import VideoCard from "./Card";
import Container from "../Container";
import PassGate from "./PassGate";
import DashboardNavbar from "../Navbars/DashboardNavbar";
import MDBox from "../MDBox";
import Card from "@mui/material/Card";
import MDTypography from "../MDTypography";
import Footer from "../Footer";
import DashboardLayout from "../LayoutContainers/DashboardLayout";

import { useUserController } from "../../context/user";
import { useMaterialUIController } from "../../context";

const cookie = new Cookies();

const CardView = () => {
  const [videos, setVideos] = useState(null);
  const [cat, setCat] = useState(null);
  const [userData, setUserData] = useState([]);
  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);

  const fetchRef = useRef(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [controller] = useMaterialUIController();
  const { spanish } = controller;

  const [userController] = useUserController();
  const { user } = userController;

  // Fetch category videos
  const getVideos = () => {
    Api.getAllCats()
      .then(({ data }) => {
        setVideos(data);
        const matchedCat = data.find((v) => v.id === id);
        setCat(matchedCat);
        fetchRef.current = true;
      })
      .catch((err) => {
        console.error("Failed to fetch categories:", err);
        setVideos([]);
      });
  };

  // Fetch videos on first load if not already fetched
  useEffect(() => {
    if (!videos && !fetchRef.current) {
      getVideos();
    }
  }, [videos]);

  // Load user data from cookie
  useEffect(() => {
    const data = cookie.get("meUserData");
    setUserData(data || []);
  }, []);

  // Fetch quizzes once videos are loaded
  useEffect(() => {
    if (videos) {
      fetchQuizzes();
    }
  }, [id, videos]);

  const fetchQuizzes = () => {
    Api.getAllQuizzes().then(({ data }) => {
      let quizzes = data.filter(
        (quiz) => quiz.cat === id || quiz.cat.includes(id)
      );

      // Sort specific category by title
      if (id === "26cf6bfe-f578-4a32-b01d-b53236b0e153") {
        quizzes.sort((a, b) =>
          a.english.title.localeCompare(b.english.title, undefined, {
            numeric: true,
            sensitivity: "base",
          })
        );
      }

      renderVideoCards(quizzes);
    });
  };

  const renderVideoCards = (quizzes) => {
    // const quizData = userData.quizData || {};
    const quizData = []; // Placeholder for quizData logic

    const cardElements = quizzes.map((quiz, index) => {
      quiz.s = quizData[quiz.id];
      return <VideoCard className="single-card-body" data={quiz} key={index} num={index} />;
    });

    setCards(cardElements);
    setFilteredCards(cardElements);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();

    if (query.length === 0) {
      setFilteredCards(cards);
      return;
    }

    const filtered = cards.filter((card) =>
      card.props.data.english.title.toLowerCase().includes(query)
    );

    setFilteredCards(filtered);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={0}>
        <Card>
          <MDBox p={3} lineHeight={1} height="80vh" sx={{ overflow: "scroll" }}>
            {cat && (
              <PassGate
                pass={cat.password}
                gate={cat.title}
                title={spanish ? cat.spanish : cat.title}
              >
                <MDTypography variant="h5">
                  {spanish ? cat.spanish : cat.title}
                </MDTypography>
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  onChange={handleSearchChange}
                  style={{
                    transition: "box-shadow 0.2s ease 0s",
                    padding: 8,
                    border: "1px solid rgba(0, 22, 66, 0.32)",
                    background: "rgb(246, 249, 250)",
                    outline: "none",
                    marginTop: 15,
                    marginBottom: 20,
                    borderRadius: 2,
                  }}
                />
                <Container spacing>{filteredCards}</Container>
              </PassGate>
            )}
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

CardView.propTypes = {
  data: PropTypes.any,
};

export default CardView;
